import React, { useState } from 'react';
import { X as XIcon, Check as CheckIcon, ChevronDown as ChevronDownIcon, FilterIcon, CalendarIcon, BriefcaseIcon, TagIcon, UserIcon, MessageSquareIcon } from 'lucide-react';
interface AdvancedFiltersProps {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilters: (filters: any) => void;
}
export const AdvancedFilters: React.FC<AdvancedFiltersProps> = ({
  isOpen,
  onClose,
  onApplyFilters
}) => {
  const [engagementType, setEngagementType] = useState<string[]>([]);
  const [relevanceLevel, setRelevanceLevel] = useState<string[]>([]);
  const [dateRange, setDateRange] = useState<string>('all');
  const [companySize, setCompanySize] = useState<string[]>([]);
  const [industry, setIndustry] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState('engagement');
  const handleToggleEngagementType = (type: string) => {
    setEngagementType(prev => prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]);
  };
  const handleToggleRelevanceLevel = (level: string) => {
    setRelevanceLevel(prev => prev.includes(level) ? prev.filter(l => l !== level) : [...prev, level]);
  };
  const handleToggleCompanySize = (size: string) => {
    setCompanySize(prev => prev.includes(size) ? prev.filter(s => s !== size) : [...prev, size]);
  };
  const handleToggleIndustry = (ind: string) => {
    setIndustry(prev => prev.includes(ind) ? prev.filter(i => i !== ind) : [...prev, ind]);
  };
  const handleApply = () => {
    onApplyFilters({
      engagementType,
      relevanceLevel,
      dateRange,
      companySize,
      industry
    });
    onClose();
  };
  const handleReset = () => {
    setEngagementType([]);
    setRelevanceLevel([]);
    setDateRange('all');
    setCompanySize([]);
    setIndustry([]);
  };
  const getFilterCount = () => {
    let count = 0;
    if (engagementType.length > 0) count++;
    if (relevanceLevel.length > 0) count++;
    if (dateRange !== 'all') count++;
    if (companySize.length > 0) count++;
    if (industry.length > 0) count++;
    return count;
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-end sm:items-center justify-center p-4" data-id="element-9">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] overflow-hidden" data-id="element-10">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-11">
          <h3 className="text-lg font-medium text-gray-900" data-id="element-12">
            Advanced Filters
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-13">
            <XIcon size={20} data-id="element-14" />
          </button>
        </div>
        <div className="border-b border-gray-200" data-id="element-15">
          <nav className="flex -mb-px" data-id="element-16">
            <button onClick={() => setActiveTab('engagement')} className={`px-4 py-3 text-sm font-medium border-b-2 flex items-center ${activeTab === 'engagement' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-17">
              <MessageSquareIcon size={16} className="mr-2" data-id="element-18" />
              Engagement
            </button>
            <button onClick={() => setActiveTab('company')} className={`px-4 py-3 text-sm font-medium border-b-2 flex items-center ${activeTab === 'company' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-19">
              <BriefcaseIcon size={16} className="mr-2" data-id="element-20" />
              Company
            </button>
            <button onClick={() => setActiveTab('date')} className={`px-4 py-3 text-sm font-medium border-b-2 flex items-center ${activeTab === 'date' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-21">
              <CalendarIcon size={16} className="mr-2" data-id="element-22" />
              Date Range
            </button>
          </nav>
        </div>
        <div className="p-4 overflow-y-auto max-h-[60vh]" data-id="element-23">
          {activeTab === 'engagement' && <div className="space-y-6" data-id="element-24">
              <div data-id="element-25">
                <h4 className="text-sm font-medium text-gray-700 mb-2 flex items-center" data-id="element-26">
                  <UserIcon size={16} className="mr-2 text-gray-500" data-id="element-27" />
                  Relevance Level
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-id="element-28">
                  {['high', 'medium', 'low'].map(level => <label key={level} className="flex items-center p-2 border rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-29">
                      <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={relevanceLevel.includes(level)} onChange={() => handleToggleRelevanceLevel(level)} data-id="element-30" />
                      <span className="ml-2 text-sm text-gray-700 capitalize" data-id="element-31">
                        {level}
                      </span>
                    </label>)}
                </div>
              </div>
              <div data-id="element-32">
                <h4 className="text-sm font-medium text-gray-700 mb-2 flex items-center" data-id="element-33">
                  <MessageSquareIcon size={16} className="mr-2 text-gray-500" data-id="element-34" />
                  Engagement Type
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-35">
                  {['liked', 'commented', 'shared', 'multiple'].map(type => <label key={type} className="flex items-center p-2 border rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-36">
                      <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={engagementType.includes(type)} onChange={() => handleToggleEngagementType(type)} data-id="element-37" />
                      <span className="ml-2 text-sm text-gray-700 capitalize" data-id="element-38">
                        {type}
                      </span>
                    </label>)}
                </div>
              </div>
            </div>}
          {activeTab === 'company' && <div className="space-y-6" data-id="element-39">
              <div data-id="element-40">
                <h4 className="text-sm font-medium text-gray-700 mb-2 flex items-center" data-id="element-41">
                  <BriefcaseIcon size={16} className="mr-2 text-gray-500" data-id="element-42" />
                  Company Size
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2" data-id="element-43">
                  {['1-10', '11-50', '51-200', '201-1000', '1001+'].map(size => <label key={size} className="flex items-center p-2 border rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-44">
                        <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={companySize.includes(size)} onChange={() => handleToggleCompanySize(size)} data-id="element-45" />
                        <span className="ml-2 text-sm text-gray-700" data-id="element-46">
                          {size} employees
                        </span>
                      </label>)}
                </div>
              </div>
              <div data-id="element-47">
                <h4 className="text-sm font-medium text-gray-700 mb-2 flex items-center" data-id="element-48">
                  <TagIcon size={16} className="mr-2 text-gray-500" data-id="element-49" />
                  Industry
                </h4>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-50">
                  {['Technology', 'Marketing', 'Finance', 'Healthcare', 'Education', 'Retail'].map(ind => <label key={ind} className="flex items-center p-2 border rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-51">
                      <input type="checkbox" className="rounded border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={industry.includes(ind)} onChange={() => handleToggleIndustry(ind)} data-id="element-52" />
                      <span className="ml-2 text-sm text-gray-700" data-id="element-53">{ind}</span>
                    </label>)}
                </div>
              </div>
            </div>}
          {activeTab === 'date' && <div data-id="element-54">
              <h4 className="text-sm font-medium text-gray-700 mb-2 flex items-center" data-id="element-55">
                <CalendarIcon size={16} className="mr-2 text-gray-500" data-id="element-56" />
                Date Range
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-57">
                {[{
              value: 'all',
              label: 'All time'
            }, {
              value: 'today',
              label: 'Today'
            }, {
              value: 'yesterday',
              label: 'Yesterday'
            }, {
              value: 'week',
              label: 'Last 7 days'
            }, {
              value: 'month',
              label: 'Last 30 days'
            }, {
              value: 'quarter',
              label: 'Last 90 days'
            }].map(option => <label key={option.value} className="flex items-center p-2 border rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-58">
                    <input type="radio" className="rounded-full border-gray-300 text-[#f9b30f] focus:ring-[#f9b30f] h-4 w-4" checked={dateRange === option.value} onChange={() => setDateRange(option.value)} name="dateRange" data-id="element-59" />
                    <span className="ml-2 text-sm text-gray-700" data-id="element-60">
                      {option.label}
                    </span>
                  </label>)}
              </div>
            </div>}
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-61">
          <div className="flex items-center" data-id="element-62">
            <button onClick={handleReset} className="text-sm text-gray-600 hover:text-gray-900 mr-3" data-id="element-63">
              Reset All
            </button>
            <span className="text-sm text-gray-500" data-id="element-64">
              {getFilterCount()} {getFilterCount() === 1 ? 'filter' : 'filters'}{' '}
              selected
            </span>
          </div>
          <div className="space-x-3" data-id="element-65">
            <button onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-66">
              Cancel
            </button>
            <button onClick={handleApply} className="px-4 py-2 bg-[#f9b30f] hover:bg-[#e0a40e] rounded-md text-sm font-medium text-white" data-id="element-67">
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>;
};